import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { AuthWrapped } from '~/modules/navigation/components'
import {
  ServicePointVendorsPage,
  ServicepointVendorDetailsPage,
  AddServicepointVendorPage,
  EditServicepointVendorPage,
} from '~/modules/servicepointvendors/view'
import { PATH } from '~/AppRoutes'

export const ServicePointVendorRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('SERVICEPOINT_VENDORS')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={ServicePointVendorsPage} canAccess={canAccess} />} />
      <Route path={PATH.ADD} element={<AuthWrapped component={AddServicepointVendorPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.EDIT}/:id`}
        element={<AuthWrapped component={EditServicepointVendorPage} canAccess={canAccess} />}
      />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={ServicepointVendorDetailsPage} canAccess={canAccess} />}
      />
    </Routes>
  )
}

export const servicePointVendorLinks = {
  servicePointVendorsLink: () => PATH.OVERVIEW,
  showServicePointVendorDetailsLink: (id: string) => `/${PATH.DETAILS}/${id}`,
  addServicePointVendorLink: () => `/${PATH.ADD}`,
  editServicePointVendorLink: (id: string) => `/${PATH.EDIT}/${id}`,
}
